<pane-back-button [buttonFacingRight]="false" text="close" backToLeftPane="chat-bar"></pane-back-button>
<div class="chat-container">
    <!-- Fixed at top -->
    <div class="chat-header glass-bar-top">
        <div class="d-flex w-100 justify-content-start align-items-center">
            <div class="profile-image-holder">
                <base64-image [base64String]="chatImageBase64"></base64-image>
            </div>
            <div class="d-flex flex-column placeholder-glow">
                <div *ngIf="!otherGuy" class="profile-name" [class.placeholder]="!chat">{{ chat?.name ?? "Loading..." }}</div>
                <div *ngIf="otherGuy" class="profile-name" [class.placeholder]="!otherGuy">{{ otherGuy?.display_name ?? "Loading..." }}</div>
                <div class="profile-status" [class.placeholder]="!otherGuy">{{ otherGuy?.tag_line ?? "Loading... Loading..." }}</div>
            </div>
        </div>
    </div>

    <!-- Scrollable middle section -->
    <div #messageContainer class="message-list" >
            <chat-message
                *ngFor="let msg of messages; trackBy: trackByMessageId"
                [message]="msg"
                [participants]="participants"
                [user]="usersById[msg.owner_id]"
                [isMe]="msg.owner_id === user?.id"
            ></chat-message>
    </div>

    <!-- Fixed at bottom, can grow -->
    <div class="new-message-bar glass-bar-bottom">
        <div class="floating">
            <div class="pane w-100 d-flex align-items-end">
            <textarea
                    [(ngModel)]="newMessageText"
                    placeholder="Type a message..."
                    rows="1"
                    (input)="autoResize($event)"
            ></textarea>
                <button class="btn btn-outline btn-emoji" (click)="sendMessage()">
                    <fa-icon [icon]="iconsService.faIconsRegular.faFaceGrinHearts"></fa-icon>
                </button>
            </div>
            <button class="btn btn-outline btn-send" (click)="sendMessage()">
                <fa-icon [icon]="iconsService.faIconsRegular.faPaperPlane"></fa-icon>
            </button>
        </div>
    </div>
</div>
